import { render } from "./XmlMapperTestView.vue?vue&type=template&id=6251290c&scoped=true&ts=true"
import script from "./XmlMapperTestView.vue?vue&type=script&lang=ts"
export * from "./XmlMapperTestView.vue?vue&type=script&lang=ts"

import "./XmlMapperTestView.vue?vue&type=style&index=0&id=6251290c&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6251290c"]])

export default __exports__